const API_BASE_URL = 'https://prod.api.teechaa.com';
// const API_BASE_URL = 'http://localhost:1976';
module.exports = {
    API_BASE_URL,
} 
